import React from 'react';
import _ from 'lodash';
import {Grid, Button, Header} from 'semantic-ui-react';
import {GRANT_ROSTER_FIELDS} from 'app-ui-componentlibrary/dist/common/constants';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import AddEmployeeModal from 'go/components/modules/roster/AddEmployeeModal';
import Position from 'go/components/modules/roster/Position';

const {EMPLOYEES} = GRANT_ROSTER_FIELDS;

const MODALS = {
  CREATE: 'create',
  EDIT: 'edit',
  CONFIRM: 'confirm',
  NONE: 'none',
};

export class GrantRoster extends React.Component {
  state = {
    openModal: MODALS.NONE,
  };

  editEmployee = (rosterId) => {
    this.setState({
      openModal: MODALS.EDIT,
      editing: rosterId,
    });
  };

  updateEmployees = (employees) => {
    const {
      entityDataPath,
      entityType,
      fundingStreamsPath,
      fundingStreamEntityType,
    } = this.props;

    this.props.saveEntityData(entityDataPath, entityType, employees);

    this.setState({
      openModal: MODALS.NONE,
    });
  };

  confirmEmployee = () => {
    this.setState({
      openModal: MODALS.CONFIRM,
    });
  };

  clearEntityDataPath = () => {
    this.props.clearEntityData('context.employee', '', this.props.validationId);
  };

  render() {
    const {
      data,
      validationId,
      editable,
      paymentStreamsModified,
      fundingStreams,
      awardedId,
    } = this.props;
    const {openModal, editing} = this.state;

    const editingEmployee = _.find(
      _.flatMap(_.map(data, (pos) => _.get(pos, EMPLOYEES, []))),
      (employee) => employee.rosterId === editing
    );

    // if there are no positions to add, don't show the roster
    if (_.isEmpty(data)) {
      return <React.Fragment />;
    }

    return (
      <React.Fragment>
        <AddEmployeeModal
          open={openModal !== MODALS.NONE}
          existingEmployee={editingEmployee}
          positions={data}
          validationId={validationId}
          confirmAction={(employees) => this.updateEmployees(employees)}
          cancelAction={() => this.setState({openModal: MODALS.NONE})}
          saveEntityData={this.props.saveEntityData}
          validationErrors={this.props.validationErrors}
          validationDirtyMap={this.props.validationDirtyMap}
          fundingStreams={fundingStreams}
          awardedId={awardedId}
          confirmEmployee={this.confirmEmployee}
          openConfirmModal={openModal === MODALS.CONFIRM}
          editable={editable}
          clearEntityData={this.clearEntityDataPath}
        />
        <Grid className="compact">
          <Grid.Row columns={2}>
            <Grid.Column textAlign="left">
              <Header as="h3">Roster</Header>
            </Grid.Column>
            <Grid.Column textAlign="right">
              {editable ? (
                <Button
                  basic
                  primary
                  onClick={() =>
                    this.setState({
                      openModal: MODALS.CREATE,
                      editing: undefined,
                    })
                  }
                >
                  Add employee
                </Button>
              ) : null}
            </Grid.Column>
          </Grid.Row>
          {_.map(data, (position, index) => {
            if (_.isEmpty(position.employees)) {
              return null;
            }
            return (
              <Grid.Row key={index}>
                <Grid.Column width={16}>
                  <Position
                    positionId={index}
                    position={position.employees}
                    editEmployee={this.editEmployee}
                    editable={editable}
                  />
                </Grid.Column>
              </Grid.Row>
            );
          })}
        </Grid>
      </React.Fragment>
    );
  }
}

export default connectDynamic(GrantRoster);
